import React from 'react';
import { useMetadata } from 'src/util/hooks/useMetadata';

// Components
import Layout from 'src/components/Layout';
import { ProductsGrid, HeroVideo, Links } from './components';

// CSS
import * as css from './Homepage.module.scss';

export function Homepage({ children }) {
    const { homepageTheme } = useMetadata();

    return (
        <Layout homepage theme={homepageTheme}>
            <div className={css.content}>
                <HeroVideo />
                <ProductsGrid />
                <Links />

                {children}
            </div>
        </Layout>
    );
}
